module.exports = __webpack_public_path__ + "static/media/salao_jardim_5.43fed894.jpg";